import { UPDATE_PARTNER } from "../constants";

const initialState = null;

export const setAboutData = (data) => ({
    type: UPDATE_PARTNER,
    data,
});

export const partner = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PARTNER:
            return action.data;
        default:
            return state;
    }
};
